import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess} from '@/utils/notification';
import {
  SYSTEM_CONFIG_WESTERN,
  SYSTEM_CONFIG_NATION,
  SYSTEM_CONFIG_DEMO,
  SYSTEM_CONFIG,
  ADD_SYSTEM_CONFIG,
  UPDATE_SYSTEM_CONFIG,
} from '@/queries/modules/system/system-config';

export async function getSystemConfigWestern(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: SYSTEM_CONFIG_WESTERN,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.systemConfigWestern
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getSystemConfigNation(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: SYSTEM_CONFIG_NATION,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.systemConfigNation
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getSystemConfigDemo(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: SYSTEM_CONFIG_DEMO,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.systemConfigDemo
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getSystemConfig(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: SYSTEM_CONFIG,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.systemConfig
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addSystemConfig(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_SYSTEM_CONFIG,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', newItemSuccess(data.addSystemConfig.nameLocal));

      return data.addSystemConfig
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateSystemConfig(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_SYSTEM_CONFIG,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      context.commit('setSuccess', updateItemSuccess(data.updateSystemConfig.nameLocal));

      return data.updateSystemConfig
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}


